import { render, staticRenderFns } from "./TwoPhaseMailVerify.vue?vue&type=template&id=c92a5e44&scoped=true&"
import script from "./TwoPhaseMailVerify.vue?vue&type=script&lang=js&"
export * from "./TwoPhaseMailVerify.vue?vue&type=script&lang=js&"
import style0 from "./TwoPhaseMailVerify.vue?vue&type=style&index=0&id=c92a5e44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c92a5e44",
  null
  
)

export default component.exports